import common from "../../../utils/common";
import c from "../../../utils/constants";

class userGuardiansController {
  constructor() {
    "ngInject"
    
  }
  
  $onInit() {
    
    this.gridOptions = {
      dataSource: this.guardians,
      sortable: true,
      pageable: false,
      resizable: true,
      noRecords: {
        template: "No Guardians."
      },
      columns: [
        { field: "firstName", title: "First Name", filterable: false, width: "6rem" },
        { field: "lastName", title: "Last Name", filterable: false, width: "6rem" },
        { field: "relationship", title: "Relationship", filterable: false, width: "4rem", template: (dataItem) => `${this._getRelationship(dataItem.relationship)}` },
        { field: "status", title: "Status", filterable: false, width: "4rem", template: (dataItem) => `${this._getGuardianStatus(dataItem.status)}` },
        { field: "email", title: "Email", filterable: false, width: "6rem" },
        { field: "phoneNumber", title: "Phone Number", filterable: false, width: "6rem" },
        { field: "submissionDate", title: "Submission Date", filterable: false, width: "4rem", template: `#= submissionDate ? kendo.toString(new Date(submissionDate), 'dd-MM-yyyy') : '-' #` },
        { field: "approvalDate", title: "Approval Date", filterable: false, width: "4rem", template: `#= approvalDate ? kendo.toString(new Date(approvalDate), 'dd-MM-yyyy') : '-' #` },
      ]
    }
  }
  
  _getGuardianStatus(status) {
    switch(status) {
      case c.guardianStatus.PENDING:
        return "Pending";
      case c.guardianStatus.APPROVED:
        return "Approved";
      case c.guardianStatus.CANCELLED:
        return "Cancelled";
      case c.guardianStatus.NONE:
        return "-";
    }
  }
  
  _getRelationship(relationship) {
    switch(relationship) {
      case c.guardianRelation.FATHER:
        return "Father";
      case c.guardianRelation.MOTHER:
        return "Mother";
      case c.guardianRelation.LEGALGUARDIAN:
        return "Legal Guardian";
    }
  } 
  
}

export default userGuardiansController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/user-guardians/user-guardians.controller.js
 **/